import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=8e5a9b1c&scoped=true&"
import script from "./Environment.vue?vue&type=script&lang=ts&"
export * from "./Environment.vue?vue&type=script&lang=ts&"
import style0 from "./Environment.vue?vue&type=style&index=0&id=8e5a9b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5a9b1c",
  null
  
)

export default component.exports